import { DsPinInterface } from '../interfaces/ds-pin.interface';

export class DsPin {
  /**
   *
   */
  public id: number;

  /**
   *
   */
  public state: number;

  /**
   * Coordinates of a pin on a 2D map. Format: 'x:y' , x and y are converted to fit inside A0 dimensions.
   */
  public coord: string;

  /**
   *
   */
  public description: string;

  /**
   *
   */
  public hasComment: number;

  /**
   *
   */
  public accountId: number;

  /**
   *
   */
  public campaignId: number;

  /**
   *
   */
  public campaign: string;

  /**
   *
   */
  public creationDate: number;

  /**
   *
   */
  public lastModificationDate: number;

  /**
   *
   */
  public dueDate: number;

  /**
   *
   */
  public photos: string;

  /**
   *
   */
  public photo: string;

  /**
   *
   */
  public mapId: number;

  /**
   *
   */
  public map: string;

  /**
   *
   */
  public mapCategoryId: number;

  /**
   *
   */
  public mapCategory: string;

  /**
   *
   */
  public companyId: number;

  /**
   *
   */
  public position: string;

  /**
   *
   */
  public positionId: number;

  /**
   *
   */
  public emitterId: number;

  /**
   *
   */
  public emitter: string;

  /**
   *
   */
  public companyName: string;

  /**
   *
   */
  public rating: number;

  /**
   * Creates an instance of DsPin.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsPinInterface) {
    this.id = jsonData.id;
    this.description = jsonData.description;
    this.hasComment = jsonData.hasComment;
    this.accountId = jsonData.accountId;
    this.campaignId = jsonData.campaignId;
    this.campaign = jsonData.campaign;
    this.creationDate = jsonData.creationDate;
    this.coord = jsonData.coord;
    this.lastModificationDate = jsonData.lastModificationDate;
    this.dueDate = jsonData.dueDate;
    this.state = jsonData.state || jsonData.state === 0 ? jsonData.state : this.state;
    this.photos = jsonData.photos;
    this.photo = jsonData.photo;
    this.mapId = jsonData.mapId;
    this.map = jsonData.map;
    this.mapCategoryId = jsonData.mapCategoryId;
    this.mapCategory = jsonData.mapCategory;
    this.companyId = jsonData.companyId;
    this.position = jsonData.position;
    this.positionId = jsonData.positionId;
    this.emitterId = jsonData.emitterId;
    this.emitter = jsonData.emitter;
    this.companyName = jsonData.companyName;
    this.rating = jsonData.rating;
  }
}
